const RELOAD_GUARD_KEY = 'vite-preload-reloaded'

/**
 * A dynamic import (route or component chunk) can fail if a new deploy
 * shipped since this page loaded, leaving the browser requesting a hashed
 * chunk that no longer exists. Reload once to pick up the new build; the
 * guard key prevents a reload loop if the failure isn't actually
 * deploy-related (e.g. the reload doesn't fix it).
 */
export function registerPreloadErrorRecovery() {
    window.addEventListener('vite:preloadError', () => {
        if (window.sessionStorage.getItem(RELOAD_GUARD_KEY)) {
            return
        }

        window.sessionStorage.setItem(RELOAD_GUARD_KEY, '1')
        window.location.reload()
    })
}

export function clearPreloadErrorGuard() {
    window.sessionStorage.removeItem(RELOAD_GUARD_KEY)
}
